import Vue from 'vue'
import axios from 'axios'

document
.querySelectorAll('.vue-newsletter')
.forEach((el) => {
    new Vue({
        el,
        data() {
            return {
                grecaptcha_sitekey: '',
                form: {
                    email: '',
                    grecaptcha_token: ''
                },
                errors: {
                    email: '',
                    grecaptcha_token: '',
                },
                success: false,
            }
        },
        mounted() {
            this.getRecaptchaSiteKey()
        },
        methods: {
            getRecaptchaSiteKey() {
                let grecaptcha_sitekey_obj = document.getElementById('grecaptcha_json');
                if (grecaptcha_sitekey_obj) {
                    this.grecaptcha_sitekey = JSON.parse(grecaptcha_sitekey_obj.innerHTML).sitekey
                }
            },
            resetErrors() {
                this.errors = {
                    email: '',
                    grecaptcha_token: ''
                }
            },
            getErrors(errors) {
                const data = {}
                const err = errors.response.data.data.params
                for(let error of err) {
                    data[error] = 'Ce champ est requis'
                }
                return data
            },
            submitForm(e) {
                e.preventDefault();
                this.resetErrors()
                grecaptcha.ready(() => {
                    grecaptcha.execute(this.grecaptcha_sitekey, {action: 'newsletter'}).then((token) => {
                        this.form.grecaptcha_token = token
                        const formData = new FormData()
                        Object.keys(this.form).forEach((key) => {
                            if (this.form[key]) {
                                formData.append(key, this.form[key])
                            }
                        })
                        axios.request({
                            method: 'POST',
                            url: "/wp-json/vq/v1/newsletter",
                            data: formData,
                            headers: {
                                'content-type': 'multipart/form-data',
                            }
                        }).then(response => {
                            this.success = true
                            this.form = {
                                email: '',
                            }
                        }).catch((error) => {
                            this.errors = this.getErrors(error)
                        })
                    })
                })
            }
        }
    })
})
